// Copyright (c) 2023 Deere & Company

import * as busyCounter from '../../../sharedmodules/action-creators/busy-counter';
import { getStore } from '../../../configmodules/store-reducer-config/store';
import { openFile } from '../../../sharedmodules/services/open-file';

export async function downloadFile(getAccessToken, file) {

    const { dispatch } = getStore();

    dispatch(busyCounter.increaseBusyCounter());

    try {

        const fileName = decodeURI(file.fileName);

        const accessTokens = await getAccessToken();
        const authorizedfetch = (url, accessToken) => fetch(url, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });

        authorizedfetch(file.source, accessTokens)
            .then((response) => response.blob())
            .then((blob) => {

                openFile(blob, fileName, 'application/octet-stream');

            });

    } catch (error) {

    } finally {

        dispatch(busyCounter.decreaseBusyCounter());

    }

}
